import { createPortal } from "react-dom";
import { X } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";
import { useAuth } from "@/context/AuthContext";

export default function Drawer({ title, subtitle, status, tone, onClose, children }) {
  const { readOnly } = useAuth();
  return createPortal(
    <div className="fixed inset-0 z-50">
      <button data-testid="drawer-backdrop" aria-label="Close drawer" className="absolute inset-0 cursor-default bg-black/40" onClick={onClose} />
      <div data-testid="node-drawer" className="absolute right-0 top-0 h-full w-full max-w-[540px] overflow-y-auto rounded-l-lg border-l border-gray-300 bg-white shadow-[-12px_0_36px_rgba(0,0,0,0.14)]">
        <div className="sticky top-0 z-10 flex items-start justify-between gap-3 border-b border-gray-200 bg-white px-6 py-5">
          <div>
            <div className="bdx-label mb-2">Stage Details</div>
            <h3 className="font-heading text-lg font-bold leading-tight text-gray-950">{title}</h3>
            {subtitle && <p className="mt-1 text-xs leading-relaxed text-gray-500">{subtitle}</p>}
            <div className="mt-2.5 flex items-center gap-2">
              {status && <StatusBadge status={status} tone={tone} />}
              {readOnly && <span data-testid="drawer-read-only" className="rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[10px] font-semibold uppercase text-amber-700" style={{ letterSpacing: "0.07em" }}>Read Only</span>}
            </div>
          </div>
          <button data-testid="drawer-close" onClick={onClose} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-gray-200 text-gray-400 transition-colors duration-150 hover:border-gray-400 hover:bg-gray-50 hover:text-gray-950" aria-label="Close drawer">
            <X size={16} strokeWidth={1.5} />
          </button>
        </div>
        <div className="px-6 py-6">{children}</div>
      </div>
    </div>,
    document.body
  );
}
